
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zhCN from 'vee-validate/dist/locale/zh_CN'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh_CN'
})
Vue.use(VeeValidate, {
  i18n,
  i18nRootKey: 'validation',
  dictionary: {
    zhCN
  },
  errorBagName: 'errorBags',
  fieldsBagName: 'filesBags'
})
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fieldBags', // 报冲突时 可自定义修改字段名称
  delay: 0, // 错误提示的延迟时间
  strict: true, // 没有设置规则的表单不进行校验，
  enableAutoClasses: false,
  locale: 'zh_CN', // 对语言（中文）的配置
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur', //* *input|blur** 在用户输入和表单失去焦点时都进行校验 可单独写  blur或input
  inject: true
}
Vue.use(VeeValidate, config)
/* eslint-disable */
const formatFileSize = function (size) {
  let units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let threshold = 1024
  size = Number(size) * threshold
  let i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + ' ' + (units[i]))
}
// 自定义validate dictionary是vee-validate中自带的规则名称,非内置属性用extend扩展
const dictionary = {
  zh_CN: {
    messages: {
      _default: (field) => `${field}无效`,
      after: (field, [target]) => `${field}必须在${target}之后`,
      alpha_dash: (field) => `${field}能够包含字母数字字符、破折号和下划线`,
      alpha_num: (field) => `${field}只能包含字母数字字符`,
      alpha_spaces: (field) => `${field}只能包含字母字符和空格`,
      alpha: (field) => `${field}只能包含字母字符`,
      before: (field, [target]) => `${field}必须在${target}之前`,
      between: (field, [min, max]) => `${field}必须在${min}与${max}之间`,
      confirmed: (field, [confirmedField]) => `${field}不能和${confirmedField}匹配`,
      credit_card: (field) => `${field}格式错误`,
      date_between: (field, [min, max]) => `${field}必须在${min}和${max}之间`,
      date_format: (field, [format]) => `${field}必须符合${format}格式`,
      decimal: (field, [decimals = '*'] = []) => `${field}必须是数字，且能够保留${decimals === '*' ? '' : decimals}位小数`,
      digits: (field, [length]) => `${field}必须是数字，且精确到${length}位数`,
      dimensions: (field, [width, height]) => `${field}必须在${width}像素与${height}像素之间`,
      email: (field) => `不是一个有效的邮箱`,
      ext: (field) => `${field}不是一个有效的文件`,
      image: (field) => `${field}不是一张有效的图片`,
      included: (field) => `${field}不是一个有效值`,
      integer: (field) => `${field}必须是整数`,
      ip: (field) => `${field}不是一个有效的地址`,
      length: (field, [length, max]) => {
        if (max) {
          return `${field}长度必须在${length}到${max}之间`
        }
        return `${field}长度必须为${length}`
      },
      max: (field, [length]) => `${field}不能超过${length}个字符`,
      max_value: (field, [max]) => `${field}必须小于或等于${max}`,
      mimes: (field) => `${field}不是一个有效的文件类型`,
      min: (field, [length]) => `${field}必须至少有${length}个字符`,
      min_value: (field, [min]) => `${field}必须大于或等于${min}`,
      excluded: (field) => `${field}不是一个有效值`,
      numeric: (field) => `${field}只能包含数字字符`,
      regex: (field) => `${field}格式无效`,
      required: (field) => `${field}不能为空`,
      size: (field, [size]) => `${field}必须小于${formatFileSize(size)}`,
      url: (field) => `${field}不是一个有效的url`
    },
    attributes: { // 对应input中name命名
      email: '邮箱',
      password: '密码',
      task_name: '任务名称',
      phone: '手机号',
      smsCode: '短信验证码',
      max: '最大长度',
      consignee: '收货人',
      area: '所在区域'
    }
  }
}

Validator.localize(dictionary)
// 规则扩展
Validator.extend('phone', {
  getMessage: field => {
    return `输入的${field}格式错误`
  },
  validate: value => {
    return /^1[3456789]\d{9}$/.test(value)
  }
})
Validator.extend('smsCode', {
  getMessage: field => {
    return `输入的${field}格式错误`
  },
  validate: value => {
    return /^[0-9]{6}$/.test(value)
  }
})
Validator.extend('word', {
  getMessage: field => {
    return `只能输入中文和英文字符`
  },
  validate: value => {
    return /^[A-Za-z\u4e00-\u9fa5]+$/.test(value)
  }
})
Validator.extend('textarea', {
  getMessage: field => {
    return `只能输入中文、英文、数字`
  },
  validate: value => {
    return /^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(value)
  }
})
// // 不验证
// export function novalid (rule, value, callback) {
//   const reg = /[\s\S]*/
//   common(rule, value, callback, reg, '不能为空')
// }
// // 手机号
// export function phone (rule, value, callback) {
//   const reg = /^1[34578]\d{9}$/
//   common(rule, value, callback, reg, '手机号不能为空', '输入的手机号格式错误')
// }
// // 邮箱
// export function email (rule, value, callback) {
//   const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
//   common(rule, value, callback, reg, '邮箱不能为空', '格式错误')
// }
// // 纯数字
// export function number (rule, value, callback) {
//   const reg = /^[0-9]+$/
//   common(rule, value, callback, reg, '不能为空', '格式错误')
// }
// // 支付数码
// export function paynumber (rule, value, callback) {
//   const reg = /^[0-9]{6}$/
//   common(rule, value, callback, reg, '不能为空', '请输入6位数字支付密码')
// }
// // 纯字母
// export function letter (rule, value, callback) {
//   const reg = /[a-zA-Z]+/
//   common(rule, value, callback, reg, '不能为空', '格式错误')
// }
// // 数字与字母
// export function numletter (rule, value, callback) {
//   const reg = /^[0-9A-Za-z]{6,20}$/
//   common(rule, value, callback, reg, '不能为空', '格式错误')
// }
// // 密码
// export function password (rule, value, callback) {
//   passwordValue = value
//   const reg = /^[0-9A-Za-z~!@#$%^&*]{6,16}$/
//   common(rule, value, callback, reg, '不能为空', '格式错误')
// }
// // 再次密码确认
// export function checkPassword (rule, value, callback) {
//   const reg = new RegExp('^' + passwordValue + '$', 'g')
//   common(rule, value, callback, reg, '不能为空', '两次密码不一致')
// }
// // 图形验证码
// export function pricture (rule, value, callback) {
//   const reg = /^[0-9A-Za-z]{4,6}$/
//   common(rule, value, callback, reg, '不能为空', '格式错误')
// }
// // 英文和中文和数字 [\u4e00-\u9fa5]
// export function letterNumberWord (rule, value, callback) {
//   const reg = /^[0-9A-Za-z\u4e00-\u9fa5]+$/
//   common(rule, value, callback, reg, '不能为空', '格式错误')
// }
// export function area (rule, value, callback) {
//   console.log(value, '\\\\\\\\')
//   // const reg = /^[0-9A-Za-z\u4e00-\u9fa5]+$/
//   // common(rule, value, callback, reg, '不能为空', '格式错误')
// }
